export const Common = {
    Error: 'Error',
    InternalError: 'Internal Error. Please contact support@curb-it.com',
    ComingSoon: 'Coming soon',
    InappropriatePhoto: 'Inappropriate photo. Please upload another one.'
}



// WEBPACK FOOTER //
// ./src/localization/Common.ts